const DETAIL = 'detail';
const SEARCH = 'search';
const GUEST = 'guest';
const GUEST_PAL_PAYMENT = 'guest-pal-payment';

export const BASE_PATH = '/service';
export const DETAIL_PATH = `${BASE_PATH}/${DETAIL}`;
export const SEARCH_PATH = `${BASE_PATH}/${SEARCH}`;
export const PAL_GUEST_PATH = `${BASE_PATH}/${GUEST}`;
export const PAL_GUEST_PAYMENT_PATH = `${BASE_PATH}/${GUEST_PAL_PAYMENT}`;

export const getLocationFromPayer = ({ zfspId, id }) => {
  return {
    pathname: `${DETAIL_PATH}/${zfspId}/${id}`,
    state: { add: true },
  };
};

export const getLocationFromGuestLoan = ({ type }) => {
  return {
    pathname: `${PAL_GUEST_PATH}/${type}`,
    state: { add: true },
  };
};
